import React, { ReactChild } from 'react';

import EditIcon from '@mui/icons-material/Edit';
import CopyAllIcon from '@mui/icons-material/CopyAll';

import GoogleMapsButton from '../../../../components/common/GoogleMapsButton';
import TranslationHelper from '../../../../helpers/TranslationHelper';
import { usePrivileges } from '../../../../state/auth/index.hooks';
import { ISourceSet, ITask } from '../../../../state/types';
import MenuDropdown from '../../../../components/MenuDropdown';
import { Box, Button } from '@mui/material';
interface IOwnProps {
    task: ITask | undefined;
    sourceSet?: ISourceSet | null;
    handleChangeMode: () => void;
    rightControls: () => ReactChild;
    copyTask: () => void;
}
const TaskPreviewRightControls = ({
    task,
    sourceSet,
    handleChangeMode,
    rightControls,
    copyTask,
}: IOwnProps) => {
    const metaHeaderTask = task?._meta.header.task;
    const privileges = usePrivileges();
    const coordinates = task?._meta.header.coordinates || undefined;
    const isReadOnly =
        metaHeaderTask?.readOnly ||
        (sourceSet?.definitionId === 'tasksPreview' &&
            !sourceSet._meta?.actions?.edit);

    return (
        <>
            <MenuDropdown>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        justifyContent: 'flex-start',
                    }}
                >
                    {privileges.addTask && (
                        <Button
                            sx={{
                                display: 'flex',
                                justifyContent: 'flex-start',
                            }}
                            fullWidth
                            onClick={copyTask}
                        >
                            <CopyAllIcon sx={{ color: 'black', mr: 1 }} />
                            {`${TranslationHelper.translate('Copy task')}`}
                        </Button>
                    )}
                    {privileges.editTask && task && !isReadOnly && (
                        <Button
                            sx={{
                                display: 'flex',
                                justifyContent: 'flex-start',
                            }}
                            fullWidth
                            onClick={handleChangeMode}
                        >
                            <EditIcon sx={{ color: 'black', mr: 1 }} />
                            {`${TranslationHelper.translate('Edit')}`}
                        </Button>
                    )}
                </Box>
            </MenuDropdown>

            <GoogleMapsButton coordinates={coordinates} />

            {rightControls()}
        </>
    );
};
export default TaskPreviewRightControls;
